{
 "versao": 2,
 "gestos": {
  "id": "gestos",
  "titulo": "Gestos do app",
  "icone": "👆",
  "secoes": [
   {
    "id": "nas-listas",
    "titulo": "Nas listas (todas as abas)",
    "passos": [
     { "id": "g-direita", "texto": "**{t:Arrastar para a direita}**: {t:Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.}", "gesto": "arrastar-direita" },
     { "id": "g-esquerda", "texto": "**{t:Arrastar para a esquerda}**: {t:Mostra Arquivar e Duplicar.}", "gesto": "arrastar-esquerda" },
     { "id": "g-ordem", "texto": "**Segurar cerca de 1 segundo e arrastar**: o item \"pega\" (vibração leve) e muda de lugar. **Passar o dedo** só rola a tela; um **toque** (mesmo demorado) edita ou abre.", "gesto": "segurar-arrastar" },
     { "id": "g-selecao", "texto": "**Segurar parado cerca de 3 segundos**: um anelzinho enche e o app entra no modo seleção (segunda vibração), para escolher vários itens de uma vez.", "gesto": "segurar-soltar" },
     { "id": "g-menu", "texto": "**{t:Menu ⋮}**: {t:Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...}", "gesto": "tocar" },
     { "id": "g-meavise", "texto": "**⏰ {t:Me avise em…}**: {t:No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.}", "gesto": "tocar" }
    ]
   },
   {
    "id": "dentro-caixa",
    "titulo": "Dentro de uma caixa e nos blocos",
    "passos": [
     { "id": "g-livre", "texto": "Não há pontinhos para arrastar: segure o cartão ou o item **cerca de 1 segundo** e arraste. Uma vibração leve avisa que ele \"pegou\". Passar o dedo só rola a tela.", "gesto": "segurar-arrastar" },
     { "id": "g-item-direita", "texto": "Itens de checklist e de lista **não deslizam** para o lado: use o **⋮ do item** › Excluir (vazio sai na hora; com texto, o app pergunta; sempre aparece o **Desfazer**).", "gesto": "arrastar-direita" },
     { "id": "g-item-esquerda", "texto": "No **⋮ do item** também ficam **Duplicar** (a cópia entra logo abaixo) e **Mover para…**. Deslizar para o lado fica só nas caixas.", "gesto": "arrastar-esquerda" },
     { "id": "g-caixa-titulo", "texto": "Toque no **título da caixa** para recolher ou abrir a caixa; fechada, ela mostra o título inteiro e o resumo embaixo (ex.: \"3 de 14 feitos\"). Para mudar o nome, use **⋮ › Renomear**.", "gesto": "tocar" },
     { "id": "g-subtitulo", "texto": "**Subtítulo**: tudo o que vem abaixo dele, até o próximo, é um grupo; um toque no subtítulo recolhe só aquele grupo. No ⋮ de um bloco de texto há \"Transformar em subtítulo\" (e o contrário).", "gesto": "tocar" },
     { "id": "g-mover-item", "texto": "**Mover itens**: arraste o item para outro grupo ou para outra caixa na tela (soltar num subtítulo fechado leva para o fim do grupo), ou use **⋮ do item › Mover para…**. Para vários: segure parado cerca de 3 segundos para selecionar, marque e toque em Mover para….", "gesto": "segurar-arrastar" },
     { "id": "g-bloco", "texto": "Nos blocos (Texto, Checklist, Lista, Desenho...): segure o bloco cerca de 1 segundo (no Desenho, a faixa de cima) e arraste para mudar de lugar; o **⋮** do bloco tem Mover para…, Inserir abaixo, Duplicar, Subir, Descer, Selecionar e Excluir. Deslizar o Texto livre, a Lista ou o Desenho para a direita exclui o bloco; para a esquerda, duplica.", "gesto": "segurar-arrastar" }
    ]
   },
   {
    "id": "recolher",
    "titulo": "Abrir e recolher",
    "passos": [
     { "id": "g-recolher", "texto": "Seções, painéis e resumos abrem e fecham com **um toque no título** (▸ fechado, ▾ aberto). Fechados, mostram um resumo curto, como \"▸ Gastos do dia · 24/10 · R$ 45,00\". O app lembra o que você deixou aberto ou fechado em cada tela.", "gesto": "tocar" }
    ]
   },
   {
    "id": "nas-paginas",
    "titulo": "Nas páginas com folha",
    "passos": [
     { "id": "g-pinca", "texto": "Afaste ou junte dois dedos na folha para dar zoom. Toque no **100%** do canto para voltar ao normal.", "gesto": "pinca" },
     { "id": "g-folha", "texto": "Segure o dedo num lugar vazio da folha: aparece o ✥. Arraste o ✥ para andar pela folha.", "gesto": "segurar-folha" },
     { "id": "g-elemento", "texto": "Segure o dedo sobre um texto, traço ou imagem para selecionar; arraste para mudar de lugar.", "gesto": "segurar-arrastar" },
     { "id": "g-bolinha", "texto": "Toque numa das 4 bolinhas de cor para usar a cor; segure a bolinha para trocar a cor dela.", "gesto": "segurar-bolinha" },
     { "id": "g-forma", "texto": "Desenhe um círculo, seta ou retângulo e segure o dedo parado no fim do traço: a forma fica perfeita." }
    ]
   },
   {
    "id": "voltar",
    "titulo": "Voltar e fechar",
    "passos": [
     { "id": "g-voltar-borda", "texto": "Puxe da borda esquerda da tela para a direita para voltar à tela anterior." },
     { "id": "g-puxar-baixo", "texto": "Puxe o topo de uma janela para baixo para fechá-la." },
     { "id": "g-voltar-android", "texto": "Se o celular tiver o botão ou o gesto de voltar, ele também leva à tela anterior." },
     { "id": "g-voltar-fim", "texto": "Voltar sempre termina no **My Planner**: na tela principal de qualquer aba, voltar leva ao My Planner, no dia de hoje." }
    ]
   },
   {
    "id": "botao-mais",
    "titulo": "O botão +",
    "passos": [
     { "id": "g-mais", "texto": "Toque no **+** no meio da barra de baixo: cria o que a tela aberta mostra (no My Planner, uma tarefa).", "mostrar": "geral.botaoMais", "gesto": "tocar" },
     { "id": "g-mais-segurar", "texto": "Segure o **+** para criar sempre uma tarefa nova no My Planner.", "mostrar": "geral.botaoMais" },
     { "id": "g-mais-apagado", "texto": "Onde não há nada para criar (ex.: {t:Mensagens}, {t:Ajustes}, {t:Abas}), o **+** fica apagadinho e o toque avisa: {t:Nesta tela não há nada para adicionar.}" }
    ]
   }
  ]
 },
 "primeirosPassos": {
  "id": "primeiros-passos",
  "titulo": "Primeiros passos",
  "icone": "🚀",
  "secoes": [
   {
    "id": "comecar",
    "titulo": "Começar a usar",
    "texto": "O app sempre abre no **My Planner**, no dia de hoje. As outras abas ficam na barra de baixo e na tela {t:Abas}.",
    "passos": [
     { "id": "pp-abas", "texto": "Toque em 🧩 {t:Abas} na barra de baixo para ver todas as abas do app.", "mostrar": "geral.barra.abas" },
     { "id": "pp-abrir", "texto": "Toque numa aba para abrir. Cada aba extra pode ser testada de graça por 10 dias." },
     { "id": "pp-barra", "texto": "Toque no 📌 de uma aba para {t:Pôr na barra}; toque de novo para {t:Tirar da barra}.", "mostrar": "abas.porNaBarra" },
     { "id": "pp-organizar", "texto": "Toque em {t:Organizar barra} para mudar a ordem das abas na barra de baixo.", "mostrar": "abas.organizarBarra" },
     { "id": "pp-mais", "texto": "Use o **+** no meio da barra para criar o que a tela aberta mostra. Quando ele está apagadinho, nesta tela não há nada para adicionar.", "mostrar": "geral.botaoMais" },
     { "id": "pp-mensagens", "texto": "💬 {t:Mensagens} fica sempre na ponta esquerda da barra de baixo." },
     { "id": "pp-voltar", "texto": "Voltar sempre termina no My Planner, no dia de hoje." }
    ]
   },
   {
    "id": "ajustes",
    "titulo": "Deixar o app do seu jeito",
    "passos": [
     { "id": "pp-ajustes", "texto": "Toque em ⚙️ {t:Ajustes} na barra de baixo.", "mostrar": "geral.barra.ajustes" },
     { "id": "pp-busca", "texto": "Digite em 🔍 {t:Buscar nos ajustes} o que procura (ex.: \"tema\", \"senha\", \"moeda\").", "mostrar": "ajustes.busca" },
     { "id": "pp-aparencia", "texto": "Em {t:Aparência}, escolha o modo claro ou escuro e o tema de cores.", "mostrar": "ajustes.aparencia" },
     { "id": "pp-seguranca", "texto": "Em {t:Segurança e dados} › {t:Segurança}, escolha como desbloquear o app.", "mostrar": "ajustes.seguranca" },
     { "id": "pp-guia", "texto": "Para rever este guia: {t:Ajustes} › {t:Ajuda e sobre} › {t:Como usar}." }
    ]
   }
  ]
 },
 "recursos": [
  {
   "id": "paginas-caneta",
   "titulo": "Páginas e caneta",
   "icone": "✒️",
   "secoes": [
    {
     "id": "barra",
     "titulo": "A barra da folha",
     "texto": "As páginas com folha existem em {t:Estudos}, {t:Anotações}, {t:Diário} e {t:Documentos}. A barra tem duas linhas e, em páginas longas, fica presa no alto da tela enquanto você rola. O passo a passo completo está no guia da aba {t:Estudos}.",
     "passos": [
      { "id": "pc-ferramenta", "texto": "Linha de cima: {t:Texto}, {t:Caneta}, {t:Marca-texto} e {t:Borracha}. A ferramenta fica até você trocar." },
      { "id": "pc-linha2", "texto": "Linha de baixo: {t:Esconder}, {t:Régua}, {t:Voltar}, {t:Refazer}, {t:Tela cheia} e {t:Mais}." },
      { "id": "pc-opcoes", "texto": "Um toque na ferramenta já abre as opções dela numa janelinha (cores, 4 bolinhas de tamanho e a barrinha, com o número e uma prévia). Ela fica aberta enquanto você escolhe; para recolher, toque na página, numa parte vazia da barra, de novo na ferramenta ou puxe para cima. Tocar na cor já escolhida abre a paleta com muitas cores." },
      { "id": "pc-desfazer", "texto": "Use {t:Voltar} para desfazer e {t:Refazer} para refazer." },
      { "id": "pc-menu", "texto": "Toque em {t:Mais} para {t:Inserir} checklist, tabela, formas ou imagem, para {t:Ferramentas} ({t:Selecionar}, {t:Mover}, {t:Régua}, {t:Limpar}), {t:Folha} e {t:Página}." },
      { "id": "pc-cheia", "texto": "Toque em {t:Tela cheia}; para voltar, toque em ✕ {t:Sair}." },
      { "id": "pc-esconder", "texto": "{t:Esconder} guarda a barra inteira; a etiqueta 🛠 {t:Ferramentas} mostra de novo. Enquanto o app estiver aberto, as próximas páginas abrem com a barra guardada." }
     ]
    },
    {
     "id": "texto",
     "titulo": "Texto na folha",
     "passos": [
      { "id": "pc-tam", "texto": "{t:Tamanho da letra}: toque num dos 4 A ou use a barrinha." },
      { "id": "pc-trecho", "texto": "Com um trecho selecionado, o tamanho, a cor e N, I e S mudam só nesse trecho." },
      { "id": "pc-duplo", "texto": "Dois toques seguidos numa palavra selecionam a palavra; puxe as alças para pegar mais palavras ou linhas." }
     ]
    },
    {
     "id": "marca",
     "titulo": "Marca-texto",
     "passos": [
      { "id": "pc-marca", "texto": "Toque em {t:Marca-texto} na barra e escolha a cor e a {t:Espessura}." },
      { "id": "pc-transp", "texto": "Use a barrinha {t:Transparência} (de 10% a 90%) para deixar a marca mais clara ou mais forte." }
     ]
    },
    {
     "id": "regua",
     "titulo": "Régua",
     "passos": [
      { "id": "pc-regua", "texto": "{t:Régua} na linha de baixo da barra liga e desliga. Arraste com um dedo para mover; gire com dois dedos." },
      { "id": "pc-regua-esticar", "texto": "Puxe uma das pontas da régua para esticar ou encolher; a outra ponta fica parada." },
      { "id": "pc-regua-grudar", "texto": "Comece o traço encostado na borda da régua: ele sai reto, grudado nela." }
     ]
    },
    {
     "id": "tela-cheia",
     "titulo": "Tela cheia",
     "passos": [
      { "id": "pc-cheia-recolher", "texto": "Na {t:Tela cheia}, a barra fica por cima da folha. Toque nos pontinhos ⠿ para recolher a barra num botão 🛠️; toque nele para mostrar de novo." },
      { "id": "pc-cheia-arrastar", "texto": "Segure os pontinhos ⠿ e arraste para levar a barra para outro lugar da tela." },
      { "id": "pc-cheia-reduzir", "texto": "Para a barra ocupar menos espaço, aproxime dois dedos sobre ela: tudo diminui junto. Ela nunca fica maior que o tamanho normal e volta a ele quando você a recolhe no 🛠️ ou sai da {t:Tela cheia}." },
      { "id": "pc-cheia-opcoes", "texto": "Toque de novo na ferramenta escolhida para ver ou esconder as opções dela." }
     ]
    },
    {
     "id": "folha",
     "titulo": "Tipo, cor e tema da folha",
     "passos": [
      { "id": "pc-folha", "texto": "Na página, toque em {t:Mais} › 📄 {t:Tipo, cor e tema da folha}." },
      { "id": "pc-folha-escolher", "texto": "Escolha o {t:TIPO DE FOLHA}, a {t:COR DA FOLHA} e o {t:TEMA DECORATIVO} e toque em {t:Pronto}." }
     ]
    },
    {
     "id": "padrao",
     "titulo": "Padrão de todas as páginas",
     "passos": [
      { "id": "pc-padrao", "texto": "Abra {t:Ajustes} › {t:Páginas e canetas}.", "mostrar": "ajustes.paginas" },
      { "id": "pc-padrao-escolher", "texto": "Escolha a folha e as 4 bolinhas. Vale para as páginas que não têm folha própria." },
      { "id": "pc-padrao-aba", "texto": "Só para uma aba: {t:Ajustes} › {t:Abas do My Planner Anne} › a aba › {t:Páginas desta aba}.", "mostrar": "ajustes.abas" }
     ]
    },
    {
     "id": "bolinhas",
     "titulo": "As 4 bolinhas de cor",
     "passos": [
      { "id": "pc-bolinha-usar", "texto": "Toque numa bolinha para usar a cor na caneta ou no texto.", "gesto": "tocar" },
      { "id": "pc-bolinha-trocar", "texto": "Segure a bolinha para trocar a cor dela; a nova cor vale para todas as páginas.", "gesto": "segurar-bolinha" },
      { "id": "pc-bolinha-marca", "texto": "O {t:Marca-texto} tem as próprias cores." }
     ]
    },
    {
     "id": "ditado",
     "titulo": "Ditar com o 🎤",
     "passos": [
      { "id": "pc-ditar", "texto": "Com {t:Texto}, {t:Caneta} ou {t:Marca-texto} escolhidos, o 🎤 aparece nas opções: toque e fale; toque no ⏹ para parar." },
      { "id": "pc-ditar-permissao", "texto": "Na primeira vez, permita o microfone e o reconhecimento de fala." }
     ]
    },
    {
     "id": "anexos",
     "titulo": "Fotos e arquivos",
     "passos": [
      { "id": "pc-anexar", "texto": "Em todas as abas, ao pôr uma imagem ou um arquivo, o app mostra 🖼️ {t:Fotos} (galeria), 📷 {t:Tirar foto} e 📎 {t:Arquivos}." },
      { "id": "pc-anexar-onde", "texto": "{t:Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).}" }
     ]
    }
   ]
  },
  {
   "id": "enviar",
   "titulo": "Enviar para outra aba",
   "icone": "📤",
   "secoes": [
    {
     "id": "item",
     "titulo": "Mandar uma cópia de um item",
     "passos": [
      { "id": "en-menu", "texto": "No item, toque em ⋮ › 📤 {t:Enviar para outra aba}.", "gesto": "tocar" },
      { "id": "en-destino", "texto": "Escolha o destino. Só aparecem as abas que você tem." },
      { "id": "en-planner", "texto": "Em 📅 {t:My Planner (vira tarefa)}, a ficha da tarefa abre preenchida: confira e salve." },
      { "id": "en-outras", "texto": "Nas outras abas, o item chega como caixa em **Anotações recebidas**, no fim da aba." },
      { "id": "en-estudos", "texto": "Em {t:Estudos}, escolha o fichário, a matéria e a página (ou {t:Nova página com esta caixa})." },
      { "id": "en-tirar", "texto": "Se o app perguntar, escolha {t:Manter aqui também} ou {t:Tirar daqui}." }
     ]
    },
    {
     "id": "lista",
     "titulo": "Mandar vários itens ou a lista inteira para o My Planner",
     "texto": "Em todas as abas: segure e solte um item para selecionar, toque em {t:Selecionar todos} (se quiser) e em 📅 {t:Enviar para o My Planner}. Só em {t:Finanças} (contas), Professor (cobranças) e Consultório (recebimentos) há também a caixa 📅 {t:Enviar para o My Planner}, que manda a lista inteira.",
     "passos": [
      { "id": "en-lista", "texto": "Toque em {t:Enviar}: os itens da lista, inclusive os novos, aparecem no My Planner." },
      { "id": "en-lista-tirar", "texto": "Para parar, toque em {t:Tirar do My Planner}." }
     ]
    },
    {
     "id": "pergunta",
     "titulo": "Itens com data e o My Planner",
     "passos": [
      { "id": "en-nada", "texto": "Nada das outras abas vai sozinho para o My Planner." },
      { "id": "en-pergunta", "texto": "Ao criar um item com data, o app pergunta: {t:Isto só aparece no My Planner se você enviar. Quer enviar agora?}" },
      { "id": "en-resposta", "texto": "Escolha {t:Enviar agora}, {t:Me lembre depois} ou {t:Não, obrigada}. Marque {t:Lembrar minha escolha nesta aba} para não perguntar de novo." },
      { "id": "en-aviso", "texto": "Com {t:Me lembre depois}, um aviso pequeno aparece embaixo da tela, com {t:Enviar agora}, {t:Me lembre depois}, {t:Não, obrigada} e {t:Escolher quando}." },
      { "id": "en-pendentes", "texto": "No My Planner, no dia de hoje, toque em {t:Ver} na linha dos itens aguardando envio para abrir {t:Aguardando envio ao My Planner}." },
      { "id": "en-aguardando", "texto": "No ⋮ de um item com data, ⏳ {t:Aguardando confirmação} marca que você espera um retorno; depois use ✅ {t:Confirmar} ou 🔔 {t:Me lembre de confirmar}." },
      { "id": "en-escolhas", "texto": "As {t:Escolhas lembradas} ficam no fim da lista, com {t:Esquecer}." }
     ]
    }
   ]
  },
  {
   "id": "arquivar-excluir",
   "titulo": "Arquivar, Excluir e Lixeira",
   "icone": "🗑️",
   "secoes": [
    {
     "id": "arquivar",
     "titulo": "Arquivar",
     "texto": "Arquivar não apaga: o item só sai da lista principal.",
     "passos": [
      { "id": "ax-arquivar", "texto": "Arraste o item para a esquerda e toque em 📦 {t:Arquivar}.", "gesto": "arrastar-esquerda" },
      { "id": "ax-arquivar-menu", "texto": "Ou toque em ⋮ › 📦 {t:Arquivar}, quando o item tiver essa opção." },
      { "id": "ax-arquivados", "texto": "Os arquivados ficam no fim da lista, em 📦 {t:Arquivados} (N) ▸. Toque para abrir." },
      { "id": "ax-restaurar", "texto": "Toque em ↩︎ {t:Restaurar} para o item voltar à lista." }
     ]
    },
    {
     "id": "excluir",
     "titulo": "Excluir",
     "passos": [
      { "id": "ax-excluir", "texto": "Arraste o item para a direita e confirme em {t:Excluir}.", "gesto": "arrastar-direita" },
      { "id": "ax-desfazer", "texto": "Logo depois aparece 🗑️ {t:Item excluído} · {t:Desfazer} por 5 segundos." },
      { "id": "ax-grande", "texto": "Itens grandes (ex.: um fichário inteiro) pedem também a senha do app ou a biometria." }
     ]
    },
    {
     "id": "varios",
     "titulo": "Vários de uma vez",
     "passos": [
      { "id": "ax-sel", "texto": "Segure e solte um item para entrar no modo seleção.", "gesto": "segurar-soltar" },
      { "id": "ax-sel-marcar", "texto": "Toque nos outros itens; {t:Todos} marca a lista inteira." },
      { "id": "ax-sel-acao", "texto": "Toque em 📦 {t:Arquivar} ou 🗑 {t:Excluir}; {t:Cancelar} sai do modo seleção." },
      { "id": "ax-sel-grande", "texto": "Itens grandes não se excluem em grupo: só um por um." }
     ]
    },
    {
     "id": "lixeira",
     "titulo": "Lixeira (30 dias)",
     "passos": [
      { "id": "ax-lixeira", "texto": "Abra {t:Ajustes} › {t:Segurança e dados} › {t:Lixeira}.", "mostrar": "ajustes.lixeira" },
      { "id": "ax-filtro", "texto": "Toque em {t:Aba} para ver só os itens de uma aba." },
      { "id": "ax-lix-restaurar", "texto": "Toque em ↩︎ {t:Restaurar}: o item volta para o lugar de onde saiu." },
      { "id": "ax-lix-apagar", "texto": "{t:Excluir de vez} apaga um item; 🗑 {t:Esvaziar a lixeira} apaga todos, sem volta." }
     ]
    }
   ]
  },
  {
   "id": "dinheiro",
   "titulo": "Dinheiro (moeda, pago/recebido, parcelas)",
   "icone": "💰",
   "secoes": [
    {
     "id": "moeda",
     "titulo": "Moeda",
     "passos": [
      { "id": "di-moeda", "texto": "Abra {t:Ajustes} › {t:Idioma e moeda} e escolha a {t:Moeda}.", "mostrar": "ajustes.idioma" },
      { "id": "di-moeda-todas", "texto": "{t:Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).}" },
      { "id": "di-moeda-valor", "texto": "Nas fichas das abas, toque no símbolo da moeda ▾ na frente de um valor para trocar só aquele valor." }
     ]
    },
    {
     "id": "pago",
     "titulo": "Marcar como pago ou recebido",
     "passos": [
      { "id": "di-quadrado", "texto": "Toque no quadradinho ☐ de uma conta ou parcela a pagar ou a receber." },
      { "id": "di-janela", "texto": "Na janela {t:Marcar como paga} (ou {t:Marcar como recebida}), confira o valor, a data e a {t:Forma de pagamento}." },
      { "id": "di-diferenca", "texto": "Se o valor for diferente do previsto, o app mostra o desconto ou a multa e juros." },
      { "id": "di-confirmar", "texto": "Toque em {t:Confirmar pagamento} (ou {t:Confirmar recebimento})." },
      { "id": "di-caixinha", "texto": "As contas de {t:Finanças} também aparecem na caixinha do My Planner, onde dá para marcar como paga." }
     ]
    },
    {
     "id": "parcelas",
     "titulo": "Parcelas",
     "passos": [
      { "id": "di-parcelado", "texto": "Conta em {t:Finanças}: em {t:Repete}, toque em {t:Parcelado} e ajuste o número de parcelas com − e +." },
      { "id": "di-cartao", "texto": "{t:Compra no cartão}: escolha as {t:Parcelas}; as próximas já aparecem nas faturas seguintes." },
      { "id": "di-financiamento", "texto": "Em {t:Empréstimos & Financiamentos}, toque em {t:Gerar as parcelas} no contrato." },
      { "id": "di-parc-planner", "texto": "No menu do contrato, 📅 {t:Pôr as parcelas no My Planner} leva os vencimentos para a agenda." }
     ]
    },
    {
     "id": "privacidade",
     "titulo": "Esconder valores e avisar antes",
     "passos": [
      { "id": "di-discreto", "texto": "Ligue 🙈 {t:Modo discreto} em {t:Ajustes} para esconder os valores (R$ •••).", "mostrar": "ajustes.discreto" },
      { "id": "di-antes", "texto": "Quantos dias antes as contas aparecem: {t:Ajustes} › {t:Avisos e alarmes} › {t:Contas a pagar}.", "mostrar": "ajustes.avisos" }
     ]
    }
   ]
  },
  {
   "id": "seguranca",
   "titulo": "Senha, biometria e segurança",
   "icone": "🔐",
   "secoes": [
    {
     "id": "desbloqueio",
     "titulo": "Desbloqueio do app",
     "texto": "Estas opções aparecem no app instalado no celular (não no My Planner Web).",
     "passos": [
      { "id": "se-abrir", "texto": "Abra {t:Ajustes} › {t:Segurança e dados} › {t:Segurança}.", "mostrar": "ajustes.seguranca" },
      { "id": "se-bloquear", "texto": "Em {t:Bloquear o app}, escolha {t:Na hora} ou depois de alguns minutos fora da tela." },
      { "id": "se-desbloquear", "texto": "Em {t:Desbloquear com}, escolha senha, PIN ou desenho padrão.", "mostrar": "ajustes.seguranca.desbloqueio" },
      { "id": "se-bio", "texto": "Ligue a chave 👆 da biometria (digital ou rosto).", "mostrar": "ajustes.seguranca.biometria" },
      { "id": "se-agora", "texto": "Toque em 🔒 {t:Bloquear agora} para trancar o app na hora." }
     ]
    },
    {
     "id": "senha",
     "titulo": "Senha da conta",
     "passos": [
      { "id": "se-mudar", "texto": "Toque em 🔑 {t:Mudar senha}, digite a atual e a nova duas vezes e toque em {t:Salvar}." },
      { "id": "se-mesma", "texto": "{t:A senha é a mesma no celular e no My Planner Web.}" }
     ]
    },
    {
     "id": "cofre",
     "titulo": "Cofre",
     "passos": [
      { "id": "se-cofre", "texto": "Em {t:Cofre (criptografia de ponta a ponta)}, toque em {t:Criar o cofre}." },
      { "id": "se-cofre-campos", "texto": "Campos com 🔒 (documentos, exames...) ficam cifrados com a senha do cofre. Sem ela, não há como recuperar." }
     ]
    },
    {
     "id": "senha-aba",
     "titulo": "Senha em uma aba",
     "passos": [
      { "id": "se-aba", "texto": "{t:Ajustes} › {t:Abas do My Planner Anne} › a aba › {t:Senha desta aba}: ligue {t:Pedir senha ao abrir esta aba}.", "mostrar": "ajustes.abas" },
      { "id": "se-aba-regra", "texto": "Em {t:Pedir de novo}, escolha {t:Toda vez que sair da aba}, {t:Depois de 5 minutos fora} ou {t:Só quando o app bloquear}." },
      { "id": "se-aba-como", "texto": "Usa o mesmo desbloqueio do app. Pede uma vez ao entrar; abrir a galeria, a câmera ou os arquivos não conta como sair." },
      { "id": "se-aba-sugere", "texto": "Em {t:Consultório}, {t:Saúde} e {t:Documentos}, o app pergunta na primeira vez: {t:Quer proteger esta aba com senha?}" },
      { "id": "se-aba-desligar", "texto": "Para desligar, o app pede a senha." }
     ]
    },
    {
     "id": "confirmar",
     "titulo": "Ações que pedem confirmação",
     "passos": [
      { "id": "se-confirmar", "texto": "Ao excluir itens grandes, o app pede a {t:Senha do app} ou {t:Biometria ou código do dispositivo}." }
     ]
    }
   ]
  },
  {
   "id": "avisos",
   "titulo": "Avisos e alarmes",
   "icone": "🔔",
   "secoes": [
    {
     "id": "padrao",
     "titulo": "Como o celular avisa",
     "passos": [
      { "id": "av-abrir", "texto": "Abra {t:Ajustes} › {t:Avisos e alarmes}.", "mostrar": "ajustes.avisos" },
      { "id": "av-modo", "texto": "Em {t:Padrão do app}, escolha {t:Alarme (som)}, {t:Vibração}, {t:Som e vibração} ou {t:Desligado}." },
      { "id": "av-vibra", "texto": "Em {t:Tipo de vibração}, escolha {t:Curta}, {t:Longa}, {t:Dupla} ou {t:Crescente}; o ▶ deixa sentir." },
      { "id": "av-aba", "texto": "Cada aba pode ter o seu: {t:Ajustes} › {t:Abas do My Planner Anne} › a aba › {t:Avisos desta aba}.", "mostrar": "ajustes.abas" }
     ]
    },
    {
     "id": "alertas",
     "titulo": "Alertas nas tarefas e nos itens com data",
     "passos": [
      { "id": "av-onde", "texto": "Nas tarefas e nos itens com data de todas as abas (fichas, documentos, garantias, contas, cartas do Diário), há o quadro de alertas." },
      { "id": "av-escolher", "texto": "Escolha {t:Sem alerta} ou ⏰ {t:Em um horário específico}. Em itens com data, escolha a hora e quando: {t:No dia}, {t:1 dia antes}..." },
      { "id": "av-horario", "texto": "Nas tarefas com horário, há também + {t:No início} e + {t:Antes do início}." },
      { "id": "av-como", "texto": "Em cada alerta, {t:Como avisar}: {t:Padrão do app} ou outro jeito, como {t:Vibração}, {t:Som e vibração} ou {t:Desligado}." },
      { "id": "av-testar-um", "texto": "O 🔔 {t:Testar} ao lado manda o aviso na hora, do jeito escolhido, e diz se algo no celular está impedindo." },
      { "id": "av-separado", "texto": "Os alertas só avisam no celular: não colocam nada no My Planner." }
     ]
    },
    {
     "id": "nao-perturbe",
     "titulo": "Não perturbe",
     "passos": [
      { "id": "av-np", "texto": "Ligue {t:Não perturbe} e escolha {t:De} e {t:Até}. Nesse horário os avisos chegam em silêncio.", "mostrar": "ajustes.avisos.naoPerturbe" }
     ]
    },
    {
     "id": "me-avise",
     "titulo": "⏰ Me avise em…",
     "passos": [
      { "id": "av-meavise", "texto": "No ⋮ de um item, toque em ⏰ {t:Me avise em…}.", "gesto": "tocar" },
      { "id": "av-quando", "texto": "Escolha {t:15 min}, {t:30 min}, {t:1 h} ou {t:Outro (escolher a hora)}." },
      { "id": "av-cancelar", "texto": "O item ganha um ⏰ pequeno. Para desmarcar: ⋮ › ⏰ {t:Cancelar aviso}." },
      { "id": "av-sem-tarefa", "texto": "Não cria tarefa no My Planner e só funciona no app instalado." }
     ]
    },
    {
     "id": "testar",
     "titulo": "Testar o alerta",
     "passos": [
      { "id": "av-testar", "texto": "Toque em 🔔 {t:Testar alerta}: o aviso chega em até 5 segundos, do jeito escolhido.", "mostrar": "ajustes.avisos.testar" },
      { "id": "av-config", "texto": "Se não chegar, toque em ⚙️ {t:Abrir configurações do celular} e ligue as notificações." },
      { "id": "av-bateria", "texto": "Deixe a bateria \"sem restrição\" e permita \"Alarmes e lembretes\" para o app." }
     ]
    }
   ]
  },
  {
   "id": "ajustes-aparencia",
   "titulo": "Ajustes e aparência",
   "icone": "⚙️",
   "secoes": [
    {
     "id": "aparencia",
     "titulo": "Aparência",
     "passos": [
      { "id": "aj-aparencia", "texto": "Abra {t:Ajustes} › {t:Aparência}.", "mostrar": "ajustes.aparencia" },
      { "id": "aj-modo", "texto": "Escolha o {t:Modo} ({t:Claro} ou {t:Escuro}), o {t:Tema} e a {t:Cor de destaque}." },
      { "id": "aj-tamanhos", "texto": "Ajuste o {t:Tamanho do texto} e o {t:Tamanho das caixas}." },
      { "id": "aj-aplicar", "texto": "Toque em {t:Aplicar} (ou {t:Aplicar tema}) embaixo. Sair sem aplicar não muda nada." }
     ]
    },
    {
     "id": "abas",
     "titulo": "Opções de cada aba",
     "passos": [
      { "id": "aj-abas", "texto": "Abra {t:Ajustes} › {t:Abas do My Planner Anne} e toque na aba.", "mostrar": "ajustes.abas" },
      { "id": "aj-cor-aba", "texto": "Em {t:Cor da aba}, troque a cor só daquela aba." },
      { "id": "aj-caixinha", "texto": "Em {t:Caixinha no My Planner}, escolha {t:Oculta}, {t:Resumida} ou {t:Completa}." },
      { "id": "aj-partes", "texto": "Nas abas que têm {t:Partes desta aba}, desmarque o que não usa: some da tela, os dados ficam." }
     ]
    },
    {
     "id": "geral",
     "titulo": "Outras opções",
     "passos": [
      { "id": "aj-idioma", "texto": "{t:Idioma e moeda}: o idioma vale para este dispositivo.", "mostrar": "ajustes.idioma" },
      { "id": "aj-calendario", "texto": "{t:Calendário}: em que dia a semana começa e o formato da hora." },
      { "id": "aj-nuvem", "texto": "{t:Nuvem e cópias de segurança}: Google Drive, OneDrive e arquivo de cópia." },
      { "id": "aj-busca", "texto": "Use 🔍 {t:Buscar nos ajustes} para achar qualquer opção.", "mostrar": "ajustes.busca" },
      { "id": "aj-versao", "texto": "{t:Atualizações e sobre}, em {t:Ajuda e sobre}, mostra a versão do app." }
     ]
    }
   ]
  }
 ],
 "perguntas": [
  { "id": "pg-alarme", "p": "Por que o alarme não tocou?", "r": "Em {t:Ajustes} › {t:Avisos e alarmes}, toque em {t:Testar alerta}. Se não chegar, ligue as notificações, deixe a bateria \"sem restrição\" e confira o {t:Não perturbe}. No alerta do item, confira {t:Como avisar}.", "mostrar": "ajustes.avisos.testar" },
  { "id": "pg-recuperar", "p": "Como recupero algo que excluí?", "r": "Logo depois de excluir, toque em {t:Desfazer}. Depois, abra {t:Ajustes} › {t:Lixeira} e toque em {t:Restaurar} (até 30 dias).", "mostrar": "ajustes.lixeira" },
  { "id": "pg-arquivar", "p": "Arquivar apaga o item?", "r": "Não. Ele vai para 📦 {t:Arquivados}, no fim da lista, e volta com {t:Restaurar}." },
  { "id": "pg-tema", "p": "Como troco o tema do app?", "r": "{t:Ajustes} › {t:Aparência} › {t:Tema}. Toque em {t:Aplicar tema} embaixo para confirmar.", "mostrar": "ajustes.aparencia" },
  { "id": "pg-pin", "p": "Esqueci o PIN ou o desenho padrão.", "r": "A senha do app continua valendo: use-a para desbloquear e troque o PIN ou o desenho em {t:Segurança}." },
  { "id": "pg-moeda", "p": "Como mudo a moeda?", "r": "{t:Ajustes} › {t:Idioma e moeda} › {t:Moeda}.", "mostrar": "ajustes.idioma" },
  { "id": "pg-barra", "p": "Como ponho uma aba na barra de baixo?", "r": "Toque em 🧩 {t:Abas} e no 📌 da aba. Para mudar a ordem, use {t:Organizar barra}.", "mostrar": "abas.porNaBarra" },
  { "id": "pg-cadeado", "p": "Uma aba aparece com 🔒. O que faço?", "r": "Cada aba extra pode ser testada de graça por 10 dias. Depois do teste, ela fica em {t:Ajustes} › {t:Compras}." },
  { "id": "pg-meavise", "p": "Não acho o ⏰ Me avise em… no menu ⋮.", "r": "Ele só aparece no app instalado no celular; no My Planner Web não há esse aviso." },
  { "id": "pg-computador", "p": "Posso usar o My Planner Web em mais de um computador ao mesmo tempo?", "r": "Não: só um computador fica conectado por vez. No celular, em Ajustes › My Planner Web, aparece o {t:Computador conectado} com o botão {t:Desconectar}. Se outro computador entrar, o app pergunta se troca. No computador, o app bloqueia sozinho depois de um tempo parado ({t:Bloquear o computador}, em Ajustes › Segurança)." },
  { "id": "pg-lixeira-aba", "p": "A Lixeira diz \"Abra a aba para poder restaurar\".", "r": "Abra a aba de onde o item saiu e volte à {t:Lixeira}: o {t:Restaurar} aparece." },
  { "id": "pg-mais-apagado", "p": "O + está apagadinho.", "r": "Nesta tela não há nada para criar. Abra a aba ou a parte onde quer criar; segurar o + cria sempre uma tarefa no My Planner.", "mostrar": "geral.botaoMais" },
  { "id": "pg-planner", "p": "Criei um item com data, mas ele não aparece no My Planner.", "r": "Nada das outras abas vai sozinho. Responda {t:Enviar agora} na pergunta, ou abra {t:Aguardando envio ao My Planner} no My Planner de hoje." },
  { "id": "pg-voltar", "p": "Voltei e o My Planner mudou de dia.", "r": "Voltar sempre termina no My Planner, no dia de hoje." },
  { "id": "pg-eventos-eu-faco", "p": "Como dividir as tarefas do dia do evento com o grupo?", "r": "No evento, abra {t:Cronograma do dia}. Quem participa do grupo toca em 🙋 {t:Eu faço} no cartão e vira responsável; cada um muda a situação ({t:A fazer}, {t:Em andamento}, {t:Feito}) e todos veem. No dia do evento aparecem {t:Agora} e {t:Próximo}." },
  { "id": "pg-meus-clientes", "p": "Onde fica a lista de clientes?", "r": "Em {t:Abas} › {t:Meus clientes}. É uma lista só: quem você cadastra lá aparece no Portal do Cliente e no Freelancer, e o que você muda num lugar muda em todos. Só o nome é obrigatório; o resto fica em partes recolhidas." },
  { "id": "pg-receber-cliente", "p": "Como registro o que um cliente me deve?", "r": "Abra o cliente em {t:Meus clientes} e toque no + para uma venda ou serviço: escolha à vista, a prazo (com as parcelas) ou sinal + restante. Em cada parcela há {t:Cobrar pelo WhatsApp}, {t:Marcar como pago} e {t:Gerar recibo}; tudo aparece em {t:Finanças}." },
  { "id": "pg-relatorio-clientes", "p": "Como vejo quanto vendi e quanto falta receber dos clientes?", "r": "Em {t:Meus clientes}, toque em 📊 {t:Relatório} no alto (ou, dentro de um cliente, em {t:Relatório deste cliente}). Escolha o mês, o ano ou as datas: aparece o que vendeu, o que recebeu, o que falta receber, os melhores clientes e os atrasados. Dá para {t:Exportar em PDF} ou {t:Exportar planilha}. O CPF/CNPJ sai só com os 2 últimos números; para sair completo, com o endereço e o nascimento, ligue {t:Incluir documentos} (pede a senha). As anotações nunca saem." },
  { "id": "pg-importar-contatos", "p": "Dá para trazer um cliente dos contatos do celular?", "r": "Sim, no app atualizado pela loja: em {t:Meus clientes}, toque em {t:Importar dos contatos do celular} e escolha o contato. Entram o nome, os telefones, o e-mail, o aniversário e o endereço; se ele já estiver na lista, o app avisa. Só o contato que você escolhe é lido." },
  { "id": "pg-escritorio-clientes", "p": "Onde ficaram as abas Escritório e Portal do Cliente?", "r": "Agora são uma aba só: {t:Escritório & Clientes}. No alto fica o escritório (toque para trocar ou criar outro); embaixo, o painel e as partes {t:Clientes}, {t:Equipe}, {t:Reuniões} e {t:Documentos internos}. Os clientes vêm de {t:Meus clientes}; tocar num cliente abre a pasta dele, com os documentos e pedidos de antes. Nada foi apagado. Trabalha sozinho? Use só os Clientes." },
  { "id": "pg-pasta-cliente", "p": "O que tem na pasta de cada cliente?", "r": "No alto: {t:Ficha completa} (abre a ficha em {t:Meus clientes}), {t:Lembrar pelo WhatsApp} e o painel com {t:Pedidos pendentes}, {t:Guias a pagar}, {t:Honorário} e {t:Recados}, além da {t:Linha do tempo}. Os documentos ficam agrupados por competência (escolha o mês, como 10/2026), com a situação Novo, Visto, A pagar ou Pago (A pagar e Pago só nas guias com vencimento). Toque em {t:Ler a guia ou o boleto com a minha IA}: ela preenche valor, vencimento, código de barras e Pix, e no ⋮ do documento aparecem {t:Copiar código de barras} e {t:Copiar Pix}. Quando o comprovante é anexado na guia (marca Comprovante), ela vira Paga sozinha. Um pedido pode se repetir todo mês, e o documento que responde ao pedido fecha o pedido. No ⋮ do cliente há o {t:Checklist de cliente novo}." },
  { "id": "pg-escritorio-equipe", "p": "Como funcionam o mural e as tarefas da equipe?", "r": "Em {t:Escritório & Clientes} › {t:Equipe}. No {t:Mural de avisos}, um recado fica fixado para todos e mostra quantos já viram (ex.: visto por 2 de 3). Em {t:Tarefas da equipe}, crie a tarefa (cliente e prazo são opcionais); quem vai fazer toca em {t:Eu faço} e depois em {t:Comecei} e {t:Terminei}. O quadro {t:Minhas tarefas} do painel mostra quantas são suas e ainda não terminou."},
  { "id": "pg-escritorio-papeis", "p": "Dá para alguém da equipe só acompanhar, sem mudar nada?", "r": "Sim. Quem administra toca no membro em {t:Equipe} › {t:Cargo e papel}: escreve o cargo (Advogada, Assistente…) e escolhe {t:Edita} ou {t:Só vê}. Quem só vê acompanha avisos, tarefas, reuniões e documentos, sem incluir nem mudar (o servidor também confere). Quem criou o escritório pode usar {t:Passar o Admin} para entregá-lo a outra pessoa."},
  { "id": "pg-escritorio-reuniao", "p": "Como marco uma reunião só com algumas pessoas, toda semana?", "r": "Em {t:Reuniões} › {t:Marcar reunião}: em {t:Quem participa}, toque nos nomes (ou deixe {t:A equipe toda}); ligue 🔁 Repetir toda semana e, se quiser, cole o link do Meet, Zoom ou Teams. Cada convidado responde {t:Vou} ou {t:Não vou}. No cartão, {t:Ata} abre o editor: escreva as anotações e toque em {t:Gerar ata com a minha IA}; as tarefas da reunião vão para as tarefas da equipe."},
  { "id": "pg-escritorio-docs", "p": "Como organizo os documentos internos do escritório?", "r": "Em {t:Documentos internos}, no ⋮ do arquivo: {t:Mover para a pasta…} (Contratos, RH, Modelos ou uma nova), {t:Fixar no topo (para todos)} e {t:Visto por e comentários}. Enviar outro arquivo com o mesmo nome guarda o anterior como versão. Só a equipe vê esta parte; clientes nunca veem."},
  { "id": "pg-escritorio-relatorio", "p": "Como tiro o relatório do mês do escritório ou de um cliente?", "r": "Em {t:Escritório & Clientes}, toque em 📊 {t:Relatório do mês}: escolha o mês, se é do escritório ou de um cliente e o que incluir. Do escritório: reuniões, tarefas, documentos internos, documentos trocados com os clientes e clientes com pendência. De um cliente: documentos da competência, pedidos, guias pagas e vencidas e honorários. CPF, CNPJ e anotações internas nunca saem no relatório."},
  { "id": "pg-pasta-extras", "p": "O que mais dá para fazer na pasta do cliente?", "r": "Os meses antigos dos documentos ficam recolhidos (toque no mês para abrir) e o {t:⬇️ Baixar o mês} junta todos os arquivos daquela competência num arquivo só. Num documento com várias fotos, 📄 Juntar as fotos num PDF transforma várias fotos num PDF e a {t:Conversa sobre este documento} guarda perguntas e respostas sobre ele. No ⋮ do pedido há {t:Guardar como modelo} e, no ⋮ do cliente, {t:Recibo do honorário…}, que já entra na pasta. As {t:🔒 Anotações internas (o cliente nunca vê)} ficam na ficha da pasta, e {t:Ver como o cliente} mostra a pasta como o cliente vê."},
  { "id": "pg-nota-rapida-telas", "p": "Dá para anotar algo rápido em Estudos, Casa, Finanças, Documentos ou Garantias?", "r": "Sim. Toque no **+** e escolha 📝 {t:Nota rápida}: abre uma caixa igual à da aba Anotações para escrever na hora. A nota fica na própria aba, em \"Anotações recebidas\". Fechando sem escrever nada, ela some."},
  { "id": "pg-nota-rapida", "p": "Quero só anotar uma listinha numa aba, sem preencher a ficha.", "r": "Toque no + e escolha 📝 {t:Nota rápida}: abre só um título (opcional) e a caixa de escrever, igual à de Anotações. A nota fica na lista como um cartão simples, com os mesmos gestos e o ⋮ com Enviar. {t:Item completo} abre a ficha de sempre." },
  { "id": "pg-eventos-convidado", "p": "Como calcular o orçamento por convidado no evento?", "r": "Em {t:Orçamento e gastos}, toque no ⊕ do item e ponha a quantidade por convidado e o valor unitário. Contam os confirmados com os acompanhantes e os extras de margem; o valor muda sozinho quando alguém confirma." }
 ],
 "abas": {
  "anotacoes": {
   "aba": "anotacoes",
   "descricao": "Lista rápida e caixas com checklist, lista, texto, subtítulos e desenho.",
   "paraQueServe": "Anote na hora o que vier à cabeça na {t:Lista rápida} e organize o resto em caixas (ex.: Compras, Ideias). Cada caixa junta checklist, lista, texto livre, subtítulos e desenho, e pode virar tarefa ou ir para outra aba.",
   "formato": "quero",
   "titulo": "Como usar as Anotações",
   "dica": "**Dica:** item que ficou em branco some sozinho quando você sai da caixa.",
   "primeirosPassos": [],
   "partes": [
    {
     "id": "an29-rapido",
     "titulo": "Anotar rápido",
     "passos": [
      {
       "id": "an29-rapido-1",
       "texto": "**Quero anotar uma coisa rapidinho** → escreva na ⚡ Lista rápida, no topo, e dê Enter. Cada Enter vira um item novo."
      },
      {
       "id": "an29-rapido-2",
       "texto": "**Quero marcar como feito** → toque no quadradinho do item."
      }
     ]
    },
    {
     "id": "an29-caixas",
     "titulo": "Criar e organizar caixas",
     "passos": [
      {
       "id": "an29-caixas-1",
       "texto": "**Quero separar por assunto** → toque em **+ Nova caixa** e dê um nome (ex.: Compras, Ideias)."
      },
      {
       "id": "an29-caixas-2",
       "texto": "**Quero acrescentar algo na caixa** → use os botões embaixo dela: ☑ Item (para marcar como feito), • Lista (com bolinhas), Texto livre, H Subtítulo ou ✍ Desenho."
      },
      {
       "id": "an29-caixas-3",
       "texto": "**Quero escrever falando** → no Texto livre, toque no 🎤 e fale."
      },
      {
       "id": "an29-caixas-4",
       "texto": "**Quero esconder o que está dentro da caixa** → toque no título. Toque de novo para abrir."
      }
     ]
    },
    {
     "id": "an29-grupos",
     "titulo": "Separar em grupos (subtítulos)",
     "passos": [
      {
       "id": "an29-grupos-1",
       "texto": "**Quero dividir a caixa em partes** → toque em **H Subtítulo** e dê um nome (ex.: Mercado, Farmácia). O que estiver embaixo dele fica no grupo."
      },
      {
       "id": "an29-grupos-2",
       "texto": "**Quero acrescentar algo dentro de um grupo** → abra o grupo e toque em **+ adicionar aqui**, no fim dele. Ou toque no nome do grupo e depois use os botões embaixo da caixa."
      },
      {
       "id": "an29-grupos-3",
       "texto": "**Quero pôr algo logo abaixo de um item** → toque no ⋮ do item › **Inserir abaixo**."
      },
      {
       "id": "an29-grupos-4",
       "texto": "**Quero esconder um grupo** → toque no nome dele. Toque de novo para abrir."
      }
     ]
    },
    {
     "id": "an29-mover",
     "titulo": "Mudar de lugar",
     "passos": [
      {
       "id": "an29-mover-1",
       "texto": "**Quero mudar uma caixa, um item ou um texto de lugar** → segure 1 segundo até vibrar e arraste."
      },
      {
       "id": "an29-mover-2",
       "texto": "**Quero mudar um desenho de lugar** → segure na faixa de cima do desenho até vibrar e arraste."
      },
      {
       "id": "an29-mover-3",
       "texto": "**Quero levar para outra caixa ou outro grupo** → segure, arraste até lá e solte. Ou toque no ⋮ › **Mover para…**"
      }
     ]
    },
    {
     "id": "an29-selecionar",
     "titulo": "Selecionar vários",
     "passos": [
      {
       "id": "an29-selecionar-1",
       "texto": "**Quero escolher vários de uma vez** → segure parado até o anelzinho encher (uns 3 segundos). Ou toque no ⋮ › **Selecionar**."
      },
      {
       "id": "an29-selecionar-2",
       "texto": "**Quero fazer algo com os selecionados** → use a faixa de baixo: Arquivar, Duplicar, Mover para…, Enviar ou Excluir."
      }
     ]
    },
    {
     "id": "an29-arquivar",
     "titulo": "Arquivar, duplicar e excluir",
     "passos": [
      {
       "id": "an29-arquivar-1",
       "texto": "**Quero excluir uma caixa** → deslize a caixa para a **direita**."
      },
      {
       "id": "an29-arquivar-2",
       "texto": "**Quero arquivar ou duplicar uma caixa** → deslize a caixa para a **esquerda**.",
       "gestos": [
        "arrastar-direita",
        "arrastar-esquerda"
       ]
      },
      {
       "id": "an29-arquivar-3",
       "texto": "**Quero excluir ou duplicar um texto, uma lista ou um desenho** → deslize o bloco para a **direita** (excluir) ou para a **esquerda** (duplicar). No desenho, deslize pela faixa de cima."
      },
      {
       "id": "an29-arquivar-4",
       "texto": "**Quero excluir, duplicar ou mover um item** → toque no ⋮ dele."
      },
      {
       "id": "an29-arquivar-5",
       "texto": "**Quero desfazer** → toque em **Desfazer**, que aparece por 5 segundos."
      },
      {
       "id": "an29-arquivar-6",
       "texto": "**Quero ver o que arquivei** → no fim da aba, toque em **📦 Arquivados**."
      },
      {
       "id": "an29-arquivar-7",
       "texto": "**Quero recuperar algo que excluí** → vá em Ajustes › **Lixeira** (fica guardado 30 dias)."
      }
     ]
    },
    {
     "id": "an29-enviar",
     "titulo": "Enviar para outro lugar",
     "passos": [
      {
       "id": "an29-enviar-1",
       "texto": "**Quero transformar uma caixa em tarefa** → toque em **Enviar para…** › My Planner. O título vira o nome da tarefa e o resto vira subtarefas e anotações."
      },
      {
       "id": "an29-enviar-2",
       "texto": "**Quero mandar uma caixa para outra aba** → toque em **Enviar para…** e escolha a aba."
      }
     ]
    }
   ],
   "dicas": [],
   "perguntas": []
  },
  "estudos": {
   "aba": "estudos",
   "descricao": "Fichários, matérias e páginas com caneta, cronômetro, metas e sessões de estudo.",
   "paraQueServe": "Organize o que você estuda em fichários (ex.: Concurso, Inglês), com matérias e páginas onde dá para escrever, desenhar com a caneta e guardar arquivos. Cronometre o estudo, defina metas por dia ou por semana e acompanhe tudo no {t:Relatório de estudos}.",
   "primeirosPassos": [
    { "id": "pp-fichario", "texto": "Toque no **+** da barra (ou em + {t:Criar fichário}) e dê um nome ao fichário.", "mostrar": "estudos.novoFichario" },
    { "id": "pp-fichario-salvar", "texto": "Toque no ícone à esquerda do nome para trocar, escolha a {t:Cor do fichário} e toque em {t:Salvar}." },
    { "id": "pp-materia", "texto": "Toque no fichário para abrir e em **+ Matéria em** (nome do fichário).", "mostrar": "estudos.novaMateria" },
    { "id": "pp-materia-salvar", "texto": "Digite o {t:Nome da matéria} e toque em {t:Salvar}." },
    { "id": "pp-pagina", "texto": "Toque na matéria e depois em + {t:Página}.", "mostrar": "estudos.novaPagina" },
    { "id": "pp-escrever", "texto": "Com {t:Texto}, toque na folha e digite; com {t:Caneta}, escreva ou desenhe com o dedo.", "mostrar": "estudos.barra.caneta" },
    { "id": "pp-salvar", "texto": "Toque em {t:Salvar} no alto. Ao fechar, a página também é salva." }
   ],
   "partes": [
    {
     "id": "ficharios",
     "titulo": "Fichários",
     "passos": [
      { "id": "fi-novo", "texto": "Toque no **+** da barra para um {t:Novo fichário}.", "mostrar": "estudos.novoFichario" },
      { "id": "fi-campos", "texto": "Digite o nome. Toque no ícone à esquerda (ou em {t:Mais}) para abrir {t:Escolher ícone}, com busca por nome." },
      { "id": "fi-icone", "texto": "Escolher só marca o ícone, sem salvar ainda; {t:Fechar} volta sem mudar. Depois escolha a {t:Cor do fichário}." },
      { "id": "fi-salvar", "texto": "Toque em {t:Salvar}. Toque no fichário para abrir ▾ ou fechar ▸.", "mostrar": "estudos.fichario" },
      { "id": "fi-editar", "texto": "Para editar, toque no ⋮ do fichário › {t:Renomear, ícone ou cor}.", "mostrar": "estudos.fichario.menu" },
      { "id": "fi-duplicar", "texto": "Para duplicar: ⋮ do fichário › ⧉ {t:Duplicar}, ou arraste o fichário para a esquerda › ⧉ {t:Duplicar}.", "gesto": "arrastar-esquerda" },
      { "id": "fi-arquivar", "texto": "Para arquivar, arraste para a esquerda › 📦 {t:Arquivar} (ou ⋮ › {t:Arquivar}).", "gesto": "arrastar-esquerda" },
      { "id": "fi-arquivados", "texto": "Os arquivados ficam em 📦 {t:Arquivados} (N), no fim da lista, com ↩︎ {t:Restaurar}.", "mostrar": "estudos.arquivados" },
      { "id": "fi-excluir", "texto": "Para excluir, arraste para a direita (ou ⋮ › {t:Excluir fichário}) e toque em {t:Excluir}.", "gesto": "arrastar-direita" },
      { "id": "fi-senha", "texto": "Por ser item grande, o app pede a senha ou a biometria. O fichário fica 30 dias na Lixeira." },
      { "id": "fi-ordem", "texto": "Para mudar a ordem, segure o fichário e, sem soltar, arraste para cima ou para baixo.", "gesto": "segurar-arrastar" },
      { "id": "fi-selecionar", "texto": "Para arquivar vários: segure um fichário parado até vibrar (ou ⋮ › ☑️ {t:Selecionar}) e toque nos outros.", "gesto": "segurar-soltar" },
      { "id": "fi-fixar", "texto": "⋮ › ⭐ {t:Fixar no topo} deixa o fichário sempre em primeiro." }
     ]
    },
    {
     "id": "materias",
     "titulo": "Matérias",
     "passos": [
      { "id": "ma-nova", "texto": "Abra o fichário e toque em **+ Matéria em** (nome), ou ⋮ do fichário › {t:Nova matéria}.", "mostrar": "estudos.novaMateria" },
      { "id": "ma-nome", "texto": "Digite o {t:Nome da matéria}; toque no ícone à esquerda para abrir {t:Escolher ícone} (com busca)." },
      { "id": "ma-categoria", "texto": "Se quiser, escolha uma {t:Categoria}: aparecem sugestões de matérias para tocar." },
      { "id": "ma-salvar", "texto": "Toque em {t:Salvar}." },
      { "id": "ma-fixar", "texto": "No ⋮ da matéria, ⭐ {t:Fixar no topo} deixa a matéria em primeiro no fichário.", "mostrar": "estudos.materia.menu" },
      { "id": "ma-editar", "texto": "Para editar: ⋮ › {t:Editar matéria}, ou abra a matéria e toque em {t:Editar}." },
      { "id": "ma-duplicar", "texto": "Para duplicar: ⋮ da matéria › ⧉ {t:Duplicar}, ou arraste a matéria para a esquerda › ⧉ {t:Duplicar}.", "gesto": "arrastar-esquerda" },
      { "id": "ma-arquivar", "texto": "Para arquivar: arraste para a esquerda › 📦 {t:Arquivar} (ou ⋮ › {t:Arquivar}).", "gesto": "arrastar-esquerda" },
      { "id": "ma-mover", "texto": "Para levar a outro fichário, segure a matéria e, sem soltar, arraste até o outro fichário.", "gesto": "segurar-arrastar" },
      { "id": "ma-selecionar", "texto": "Para escolher várias, até de fichários diferentes: segure uma matéria parada até vibrar, ou ⋮ › ☑️ {t:Selecionar}.", "gesto": "segurar-soltar" },
      { "id": "ma-selecao-acao", "texto": "Toque nas outras para marcar. Use {t:Selecionar todas}, 📦 {t:Arquivar}, 🗑 {t:Excluir} ou {t:Cancelar}." },
      { "id": "ma-excluir", "texto": "Para excluir: arraste para a direita ou ⋮ › {t:Excluir matéria}. O tempo estudado fica no histórico.", "gesto": "arrastar-direita" }
     ]
    },
    {
     "id": "paginas",
     "titulo": "Páginas",
     "passos": [
      { "id": "pa-nova", "texto": "Abra a matéria e toque em + {t:Página}.", "mostrar": "estudos.novaPagina" },
      { "id": "pa-nome", "texto": "O nome é opcional: sem nome, a página usa o {t:Título} escrito no topo da folha." },
      { "id": "pa-revisada", "texto": "Toque no quadradinho ao lado da página para marcá-la como revisada ✓.", "mostrar": "estudos.pagina.revisada" },
      { "id": "pa-folha", "texto": "Para mudar a folha, toque em {t:Mais} na barra › 📄 {t:Tipo, cor e tema da folha}.", "mostrar": "estudos.menu.folha" },
      { "id": "pa-tipo", "texto": "Em {t:TIPO DE FOLHA}: {t:Lisa}, {t:Pautada}, {t:Pautada com margem}, {t:Quadriculada} ou {t:Pontilhada}." },
      { "id": "pa-cor", "texto": "Escolha a {t:COR DA FOLHA} e um {t:TEMA DECORATIVO}; com tema, ajuste {t:Desenho mais fraco ou mais forte}." },
      { "id": "pa-todas", "texto": "Marque ☐ {t:Aplicar a todas as páginas desta matéria} e toque em {t:Pronto}." },
      { "id": "pa-padrao", "texto": "Padrão de todas as páginas do app: {t:Ajustes} › {t:Páginas e canetas}.", "mostrar": "ajustes.paginas" },
      { "id": "pa-padrao-aba", "texto": "Só para Estudos: {t:Ajustes} › {t:Abas do My Planner Anne} › {t:Estudos} › {t:Páginas desta aba}.", "mostrar": "ajustes.abas.estudos.paginas" },
      { "id": "pa-mover", "texto": "Para mudar de matéria, segure a página e solte numa das matérias que aparecem no topo.", "gesto": "segurar-arrastar" },
      { "id": "pa-menu", "texto": "No ⋮ da página: ⧉ {t:Duplicar}, ☑️ {t:Selecionar}, enviar, fixar, 📦 {t:Arquivar} e {t:Excluir página}." },
      { "id": "pa-selecionar", "texto": "Segure uma página parada até vibrar para escolher várias e arquivar ou excluir juntas.", "gesto": "segurar-soltar" },
      { "id": "pa-excluir", "texto": "Para excluir, arraste a página para a direita, use ⋮ › {t:Excluir página} ou o botão no fim dela.", "gesto": "arrastar-direita" }
     ]
    },
    {
     "id": "caneta",
     "titulo": "Usar a caneta e o texto",
     "passos": [
      { "id": "ca-ferramenta", "texto": "Na linha de cima da barra, toque em {t:Texto}, {t:Caneta}, {t:Marca-texto} ou {t:Borracha}. Ela fica até você trocar.", "mostrar": "estudos.barra.caneta" },
      { "id": "ca-texto", "texto": "Com {t:Texto}, toque na linha da folha e digite: as letras assentam na linha. Use N, I e S." },
      { "id": "ca-tamanho", "texto": "{t:Tamanho da letra}: toque num dos 4 A ou use a barrinha. Com um trecho selecionado, muda só nesse trecho." },
      { "id": "ca-duplo", "texto": "Dois toques seguidos numa palavra selecionam a palavra; puxe as alças para pegar mais." },
      { "id": "ca-bolinhas", "texto": "4 bolinhas de cor: toque para usar a cor; segure para trocar a cor da bolinha.", "mostrar": "estudos.barra.bolinhas", "gesto": "segurar-bolinha" },
      { "id": "ca-espessura", "texto": "Com {t:Caneta}, a {t:Espessura} tem 4 bolinhas de tamanho e uma barrinha para o ajuste fino, com prévia.", "mostrar": "estudos.barra.espessura" },
      { "id": "ca-forma", "texto": "Segure o dedo parado no fim de um traço: ele vira forma perfeita (círculo, seta...)." },
      { "id": "ca-marca", "texto": "{t:Marca-texto} fica na barra: escolha a cor, a {t:Espessura} e a {t:Transparência}." },
      { "id": "ca-borracha", "texto": "Com {t:Borracha}, escolha o {t:Tamanho da borracha} (4 bolinhas ou a barrinha) e passe o dedo: apaga só o pedaço." },
      { "id": "ca-desfazer", "texto": "{t:Voltar} desfaz e {t:Refazer} refaz o último passo.", "mostrar": "estudos.barra.desfazer" },
      { "id": "ca-selecionar", "texto": "Segure sobre um texto, traço ou imagem para selecionar; arraste para mover.", "gesto": "segurar-arrastar" },
      { "id": "ca-selecao", "texto": "Com algo selecionado: ⧉ {t:Duplicar}, 🎨 {t:Cor atual} (abre as cores e pinta o que está selecionado), A− e A+ (texto), 🗑 {t:Excluir} e {t:Pronto}. Na tela cheia, a faixa fica ao lado do Sair só com os ícones ⧉ 🗑 ⋯ e o Pronto; a cor e o tamanho ficam no ⋯." },
      { "id": "ca-zoom", "texto": "Para o zoom, afaste ou junte dois dedos; toque no **100%** do canto para voltar.", "gesto": "pinca" },
      { "id": "ca-andar", "texto": "Para andar pela folha, segure num lugar vazio e arraste o ✥ (ou {t:Mais} › ✋ {t:Mover}).", "gesto": "segurar-folha" },
      { "id": "ca-inserir", "texto": "{t:Mais} › {t:Inserir}: ☑️ {t:Checklist}, ▦ {t:Tabela}, ⬠ {t:Formas} ou 🖼️ {t:Imagem}.", "mostrar": "estudos.barra.menu" },
      { "id": "ca-imagem", "texto": "🖼️ {t:Imagem} abre: 🖼️ {t:Fotos} (galeria), 📷 {t:Tirar foto} ou 📎 {t:Arquivos}. A imagem entra na mesma página." },
      { "id": "ca-regua", "texto": "{t:Régua} na linha de baixo da barra (ou {t:Mais} › {t:Ferramentas} › 📏 {t:Régua}) liga e desliga. Arraste com um dedo para mover.", "mostrar": "estudos.barra.menu" },
      { "id": "ca-regua-esticar", "texto": "Puxe uma das pontas da régua para esticar ou encolher." },
      { "id": "ca-regua-girar", "texto": "Gire a régua com dois dedos: ela encaixa em 30°, 45°, 60° e 90° e mostra o ângulo na tela." },
      { "id": "ca-regua-grudar", "texto": "Comece o traço encostado na borda da régua: ele sai reto, grudado nela. As {t:Formas} também nascem encostadas." },
      { "id": "ca-ditar", "texto": "Nas opções de {t:Texto}, {t:Caneta} ou {t:Marca-texto}, toque no 🎤 e fale para ditar; toque no ⏹ para parar.", "mostrar": "estudos.barra.ditado" },
      { "id": "ca-cheia", "texto": "{t:Tela cheia} ocupa a tela toda. Para voltar, toque em ✕ {t:Sair}. Em telas maiores, dá para girar.", "mostrar": "estudos.barra.telaCheia" },
      { "id": "ca-cheia-barra", "texto": "Na tela cheia, toque nos pontinhos ⠿ para recolher a barra num botão 🛠️; segure e arraste os ⠿ para outro lugar; aproxime dois dedos sobre a barra para deixá-la menor (ao recolher no 🛠️ ou sair da tela cheia, ela volta ao tamanho normal). Toque de novo na ferramenta para ver as opções dela." },
      { "id": "ca-esconder", "texto": "{t:Esconder} guarda a barra inteira; a etiqueta 🛠 {t:Ferramentas} mostra de novo. Com a página aberta para escrever, a barra fica presa no alto enquanto você rola; com o teclado aberto, vira uma linha só de ícones logo acima dele, com ⌄ {t:Fechar teclado}." },
      { "id": "ca-pagina", "texto": "{t:Mais} › {t:Página}: {t:Voltar ao início da folha}, {t:Exportar em PDF} ou {t:Exportar como imagem}." },
      { "id": "ca-blocos", "texto": "Abaixo da folha, adicione blocos: {t:Texto}, {t:Checklist}, {t:Lista}, ✍️ {t:Caneta} ou ＋ {t:Mais}. Em cada bloco: segure no cabeçalho (a faixa de cima) e arraste para mudar de lugar; um toque no cabeçalho recolhe o bloco (fica só a 1ª linha) e outro abre; o ⋮ do cabeçalho tem Duplicar, Subir, Descer e Excluir.", "mostrar": "estudos.blocos" }
     ]
    },
    {
     "id": "arquivos",
     "titulo": "Arquivos da matéria",
     "passos": [
      { "id": "ar-adicionar", "texto": "Na matéria, toque em 📎 {t:Adicionar arquivo} e escolha 🖼️ {t:Fotos}, 📷 {t:Tirar foto} ou 📎 {t:Arquivos}.", "mostrar": "estudos.materia.arquivos" },
      { "id": "ar-nuvem", "texto": "Em 📎 {t:Arquivos}, escolha do dispositivo, Drive, OneDrive ou Dropbox. Ao voltar, você está na mesma matéria." },
      { "id": "ar-pagina", "texto": "O arquivo vai para a página **{t:Arquivos}** da matéria." },
      { "id": "ar-ver", "texto": "🗂️ {t:Ver arquivos} mostra arquivos, imagens e links de todas as páginas; segure e arraste para ordenar." },
      { "id": "ar-abrir", "texto": "Toque num arquivo para abrir na pré-visualização do celular; ao fechar, volta para a lista." }
     ]
    },
    {
     "id": "cronometro",
     "titulo": "Cronometrar o estudo",
     "passos": [
      { "id": "cr-iniciar", "texto": "Toque no ▶ ao lado da matéria, ou abra a matéria e toque em ▶ {t:Estudar agora}.", "mostrar": "estudos.materia.play" },
      { "id": "cr-um", "texto": "Só um cronômetro por vez. Com uma sessão correndo, o ▶ de outra matéria pergunta {t:Pausar a sessão e estudar só esta?}" },
      { "id": "cr-sessao", "texto": "Enquanto ele corre, a sessão fica pausada numa linha no topo. Ao continuar a sessão, o app oferece {t:Encerrar e salvar} o cronômetro." },
      { "id": "cr-pausar", "texto": "No cartão do topo, toque em {t:Pausar} e depois em {t:Continuar}.", "mostrar": "estudos.crono" },
      { "id": "cr-encerrar", "texto": "Toque em {t:Encerrar e salvar}: o tempo entra no total da semana e na meta." },
      { "id": "cr-descartar", "texto": "{t:Descartar} joga fora o tempo marcado. Menos de 1 minuto não é registrado." }
     ]
    },
    {
     "id": "meta",
     "titulo": "Meta de estudo",
     "passos": [
      { "id": "me-abrir", "texto": "Toque na matéria para abrir.", "mostrar": "estudos.materia" },
      { "id": "me-tipo", "texto": "No quadro {t:Meta}, escolha {t:Por dia} ou {t:Por semana}.", "mostrar": "estudos.materia.meta" },
      { "id": "me-valor", "texto": "Toque em − ou + para mudar a meta de 30 em 30 minutos." },
      { "id": "me-feito", "texto": "Embaixo aparece quanto já foi estudado na semana." }
     ]
    },
    {
     "id": "sessao",
     "titulo": "Sessão de estudo",
     "texto": "{t:Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.}",
     "passos": [
      { "id": "se-abrir", "texto": "Toque em ▶ {t:Sessão de estudo} no topo da aba.", "mostrar": "estudos.sessao" },
      { "id": "se-nova", "texto": "Toque em + {t:Nova sessão} e dê um nome.", "mostrar": "estudos.sessao.nova" },
      { "id": "se-partes", "texto": "Toque em + {t:Matéria} e escolha: o tempo já vem sugerido pela meta dela. Use + ☕ {t:Pausa} para os intervalos." },
      { "id": "se-minutos", "texto": "Ajuste os minutos de cada parte com − e +; ↑ ↓ mudam a ordem e ✕ tira." },
      { "id": "se-salvar", "texto": "Toque em {t:Salvar}. A sessão fica guardada para repetir em outros dias." },
      { "id": "se-comecar", "texto": "Toque em ▶ {t:Começar}: o app abre direto a primeira matéria, com o tempo correndo." },
      { "id": "se-em-sessao", "texto": "Na lista, a matéria da vez mostra {t:Em sessão} no lugar do ▶. Dentro dela, o mini cartão {t:Em sessão} fica no lugar do {t:Estudar agora}." },
      { "id": "se-troca", "texto": "Na troca de matéria, o celular vibra e aparece o aviso com o botão para abrir a próxima. Ela não abre sozinha." },
      { "id": "se-controles", "texto": "Use ⏸ {t:Pausar}, ▶ {t:Continuar}, ⏭ {t:Próxima} e ⏹ {t:Encerrar}." },
      { "id": "se-selecionar", "texto": "Segure uma sessão salva até vibrar para escolher várias e excluir juntas.", "gesto": "segurar-soltar" },
      { "id": "se-plano", "texto": "Na sessão, ligue 🎯 {t:Plano com período} para um prazo: {t:Começa em}, {t:Termina em}, {t:Horas por dia} e {t:Dias da semana}." },
      { "id": "se-plano-so", "texto": "{t:O plano fica só em Estudos (não vai para o My Planner).}" },
      { "id": "se-plano-topo", "texto": "No topo da aba aparece o progresso do plano (ex.: 🎯 Dia 12 de 90 · hoje 2h de 4h). Nos dias não marcados, {t:hoje é folga}." },
      { "id": "se-plano-fim", "texto": "No fim, {t:Seu plano terminou} pergunta: {t:Encerrar} ou {t:Prolongar} com uma nova data final. Nada é apagado." }
     ]
    },
    {
     "id": "relatorio",
     "titulo": "Esta semana e Relatório de estudos",
     "passos": [
      { "id": "re-painel", "texto": "No topo da aba, toque em ▸ {t:ESTA SEMANA} para abrir o painel.", "mostrar": "estudos.semana" },
      { "id": "re-materias", "texto": "O painel mostra até 4 matérias com o feito e a meta; a barra fica verde ao bater a meta." },
      { "id": "re-abrir", "texto": "Toque em 📊 {t:Relatório de estudos} ›.", "mostrar": "estudos.relatorio" },
      { "id": "re-semanas", "texto": "Escolha {t:Semana} ou {t:Mês}; ◀ e ▶ no alto andam para os períodos anteriores." },
      { "id": "re-filtro", "texto": "Toque em {t:Todos os fichários} ou num fichário para ver só ele." },
      { "id": "re-total", "texto": "No alto: {t:Meta somada}, {t:Estudado} e {t:Faltou}. Em cada matéria, a meta, o estudado e quanto faltou ou superou." },
      { "id": "re-graficos", "texto": "Veja {t:POR DIA}, {t:POR MATÉRIA} e {t:ÚLTIMAS 8 SEMANAS} (no mês, {t:ÚLTIMOS 6 MESES}); toque numa barra para ir àquele período." },
      { "id": "re-pdf", "texto": "📄 {t:Exportar em PDF} abre a janela de compartilhar; o relatório fica guardado logo abaixo." }
     ]
    },
    {
     "id": "planner-grupos",
     "titulo": "My Planner e grupo de estudos",
     "passos": [
      { "id": "pg-agendar", "texto": "No ⋮ do fichário, toque em 📅 {t:Agendar no My Planner}.", "mostrar": "estudos.fichario.menu" },
      { "id": "pg-dias", "texto": "Marque os dias, o horário e a {t:Duração de cada sessão} e toque em {t:Salvar no My Planner}." },
      { "id": "pg-materia", "texto": "Na matéria, 📅 {t:Enviar para My Planner} faz o mesmo, ou {t:Só uma vez (abrir a ficha da tarefa)}." },
      { "id": "pg-grupos", "texto": "Toque em 👥 no alto da aba para abrir os {t:Grupos de estudo}.", "mostrar": "estudos.grupos" },
      { "id": "pg-convidar", "texto": "No ⋮ do fichário, 👥 {t:Grupo de estudos (convidar colegas)} cria um grupo com ele." },
      { "id": "pg-fichario-grupo", "texto": "No grupo, o cartão 📚 {t:Fichário do grupo} mostra o que os colegas veem: {t:Trocar fichário} ou {t:Parar de compartilhar}.", "mostrar": "estudos.grupos" },
      { "id": "pg-colegas", "texto": "Os colegas tocam em 📚 {t:Abrir o fichário do grupo} e só leem na tela: não editam, não baixam, não imprimem nem compartilham." },
      { "id": "pg-enviar", "texto": "Na matéria, 📤 {t:Enviar para o grupo de estudos} manda as páginas e os links." }
     ]
    }
   ],
   "dicas": [
    { "id": "di-direita", "texto": "Arraste fichário, matéria ou página para a direita para excluir.", "gesto": "arrastar-direita" },
    { "id": "di-esquerda", "texto": "Arraste para a esquerda para 📦 {t:Arquivar} ou ⧉ {t:Duplicar}.", "gesto": "arrastar-esquerda" },
    { "id": "di-selecao", "texto": "Segure uma matéria ou página parada até vibrar: entra na seleção, sem abrir. Toque nas outras para marcar.", "gesto": "segurar-soltar" },
    { "id": "di-selecionar-menu", "texto": "Outro caminho para a seleção: ⋮ do fichário, da matéria ou da página › ☑️ {t:Selecionar}." },
    { "id": "di-meavise", "texto": "No ⋮ do fichário ou da matéria, ⏰ {t:Me avise em…} lembra você de estudar mais tarde.", "gesto": "tocar" },
    { "id": "di-enviar", "texto": "⋮ › 📤 {t:Enviar para outra aba} manda a lista de matérias ou de páginas para outra aba." },
    { "id": "di-recebidas", "texto": "O que outras abas mandam para Estudos aparece em **Anotações recebidas**, no fim da aba." },
    { "id": "di-desfazer", "texto": "Excluiu sem querer? Toque em {t:Desfazer} na faixa que aparece embaixo." },
    { "id": "di-voltar", "texto": "Puxe da borda esquerda para voltar (página › matéria › Estudos › My Planner, no dia de hoje). Com {t:Caneta} ou {t:Borracha}, esse gesto fica desligado." },
    { "id": "di-puxar", "texto": "Puxe o topo de uma janela para baixo: é o mesmo que {t:Fechar}." }
   ],
   "perguntas": [
    { "id": "q-tema", "p": "Como troco o tema da página?", "r": "Na página, toque em {t:Mais} › 📄 {t:Tipo, cor e tema da folha} e escolha em {t:TEMA DECORATIVO}. Para todas da matéria, marque {t:Aplicar a todas as páginas desta matéria}.", "mostrar": "estudos.menu.folha" },
    { "id": "q-apagar", "p": "Como apago um fichário?", "r": "Arraste o fichário para a direita (ou ⋮ › {t:Excluir fichário}), toque em {t:Excluir} e confirme com a senha ou a biometria. Ele fica 30 dias na {t:Lixeira}.", "mostrar": "estudos.fichario.menu" },
    { "id": "q-recuperar", "p": "Excluí sem querer. Dá para recuperar?", "r": "Sim: toque em {t:Desfazer} logo depois, ou abra {t:Ajustes} › {t:Lixeira} e toque em {t:Restaurar}.", "mostrar": "ajustes.lixeira" },
    { "id": "q-tempo", "p": "Se eu excluir uma matéria, perco o tempo estudado?", "r": "Não. {t:Apaga as páginas desta matéria. O tempo estudado continua no histórico.}" },
    { "id": "q-cores", "p": "Como mudo as cores da caneta?", "r": "Segure uma das 4 bolinhas na barra e escolha a cor. Para mudar de uma vez: {t:Ajustes} › {t:Páginas e canetas} › {t:AS 4 BOLINHAS DE COR}.", "mostrar": "ajustes.paginas" },
    { "id": "q-revisada", "p": "Para que serve o quadradinho ao lado da página?", "r": "Marca a página como revisada ✓. A matéria mostra quantas páginas já foram revisadas." },
    { "id": "q-microfone", "p": "O 🎤 não funciona.", "r": "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular. Se o app pedir, atualize pela loja." },
    { "id": "q-painel", "p": "Minha matéria não aparece em ESTA SEMANA.", "r": "O painel mostra até 4 matérias com tempo ou meta. As outras estão no 📊 {t:Relatório de estudos}.", "mostrar": "estudos.relatorio" },
    { "id": "q-sessao", "p": "Sumiu o botão Sessão de estudo.", "r": "Durante uma sessão, o botão some e aparece o cartão da sessão no topo. Ao tocar em {t:Encerrar}, ele volta." },
    { "id": "q-dobro", "p": "Com sessão e cronômetro, o tempo conta duas vezes?", "r": "Não. Só um cronômetro corre por vez: cada minuto entra uma vez na meta e no 📊 {t:Relatório de estudos}." },
    { "id": "q-fotos", "p": "Ao adicionar imagem, abre Arquivos em vez das Fotos.", "r": "Toque em 🖼️ {t:Fotos} no menu. Se aparecer que a galeria chega na próxima versão, atualize o app pela loja; até lá, use 📎 {t:Arquivos} ou 📷 {t:Tirar foto}." },
    { "id": "q-grupo", "p": "Meus colegas do grupo precisam assinar para ver o fichário?", "r": "Não. Eles veem na tela, só para ler, o fichário escolhido em 📚 {t:Fichário do grupo}. Para criar fichários e usar cronômetro e relatório, é preciso ter a aba Estudos.", "mostrar": "estudos.grupos" },
    { "id": "q-grupo-editar", "p": "Estou no grupo de alguém. Por que não consigo editar?", "r": "No grupo você vê na tela o que foi compartilhado. Ao tocar em editar, cronômetro ou adicionar, o app mostra a aba Estudos: {t:Conhecer a aba} ou {t:Agora não}." }
   ]
  }
 },
 "descricoes": {
  "planner": "Linha do tempo do dia, tarefas, energia e alertas.",
  "anotacoes": "Listas rápidas e caixas que viram tarefa ou vão para outra aba.",
  "casa": "Cômodos da casa e as tarefas de cada um.",
  "estudos": "Fichários, matérias e páginas com caneta, cronômetro, metas e sessões de estudo.",
  "bemestar": "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.",
  "financas": "Contas, cartões e faturas, orçamento, metas, extrato e relatório.",
  "garantias": "Nota fiscal, assistência técnica e aviso antes de a garantia acabar.",
  "documentos": "Cofre com criptografia para documentos, com aviso de vencimento.",
  "monitor": "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.",
  "scanner": "Escaneie documentos e recibos e guarde em PDF.",
  "pdfedit": "Juntar, dividir, assinar, comprimir, converter e mais ferramentas de PDF.",
  "escritorio": "Clientes e equipe num lugar só: a pasta de cada cliente (documentos, pedidos, guias), conversa, reuniões de vídeo e documentos internos.",
  "saude": "Histórico da família, exames, vacinas, consultas e alarme dos remédios.",
  "alimentacao": "Cardápio da semana, receitas, lista de compras e validade da despensa.",
  "plantas": "Ficha de cada planta e calendário de rega e adubo.",
  "familia": "Vacinas e remédios dos pets e a rotina das crianças.",
  "veiculos": "Troca de óleo, revisões, IPVA, licenciamento e seguro.",
  "obras": "Cronograma por etapa, diário da obra, profissionais e entregas.",
  "hospedagem": "Reservas, limpeza no check-out, despesas, ocupação e lucro do mês.",
  "mudanca": "Caixas por cômodo, troca de serviços, vistorias e cronograma.",
  "patrimonio": "Imóveis, veículos e ações, recibos dedutíveis e calendário do imposto.",
  "emprestimos": "Financiamentos e empréstimos com parcelas e objetos emprestados.",
  "freelancer": "Quadro Kanban, horas por cliente e prazos no My Planner.",
  "consultorio": "Pacientes, evolução, prescrições, convênio, recibo e declaração.",
  "notas": "Emitir NFS-e, buscar notas emitidas e recebidas e exportar.",
  "portal": "Uma pasta para cada cliente trocar documentos com você.",
  "clientes": "Uma lista só de clientes, usada pelo Portal do Cliente e pelo Freelancer: contato, endereço, etiquetas, anotações, arquivos, recebimentos e relatório em PDF e planilha.",
  "professor": "Turmas, alunos, chamada, notas, materiais e cobranças.",
  "diario": "Meu Dia, hábitos, projeto de vida, sonhos e conquistas, com senha.",
  "eventos": "Convidados por situação, fornecedores com sinal, cronograma com \"Eu faço\", orçamento por convidado, compras, preparação e relatório.",
  "viagens": "Roteiro por dia, mala pelo clima, reservas e fusos.",
  "leitura": "Livros, filmes, séries e cursos com metas, progresso e resumos."
 }
}
